import React from "react";
import styled from "@emotion/styled";
import RadioGroup from "@components/button/RadioGroup";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
});

const ContentBox = styled.div({
  display: "flex",
  gap: "3rem",
});

const LabelBox = styled.div({
  fontSize: "1.6rem",
  lineHeight: "2rem",
  minWidth: "8rem",
});

const PolicyRadioGroup = () => {
  const optionsArr = [
    {
      title: "교환",
      name: "is_exchange_allowed",
      items: [
        {
          label: "가능",
          value: true,
        },
        {
          label: "불가능",
          value: false,
        },
      ],
    },
    {
      title: "환불",
      name: "is_refund_allowed",
      items: [
        {
          label: "가능",
          value: true,
        },
        {
          label: "불가능",
          value: false,
        },
      ],
    },
    {
      title: "반품",
      name: "is_return_allowed",
      items: [
        {
          label: "가능",
          value: true,
        },
        {
          label: "불가능",
          value: false,
        },
      ],
    },
  ];

  return (
    <Container>
      {optionsArr.map((item, index) => (
        <ContentBox key={index}>
          <LabelBox>{item.title}</LabelBox>
          <RadioGroup name={item.name} options={item.items} />
        </ContentBox>
      ))}
    </Container>
  );
};

export default PolicyRadioGroup;
